export class Timewindow {
  constructor(
    public min: any = '00:00',
    public max: any = '23:59'
  ) {}
}
